import React, {Fragment, useEffect} from 'react';
import {getFileUrl} from '../../services/docs';
import {useParams} from 'react-router-dom';
import { toast } from 'react-toastify';

const ViewFile = () => {
  const {hash} = useParams(); 

  const getFile = async (hash: any) => {
    const res = await getFileUrl(hash);
    if (res.status === 200) {
      window.location.href = res.data.imageLink;
    } else {
      toast("Unable to fetch file");
      window.location.href = '/';
    }
  };

  useEffect(() => {
    if (hash) {
      getFile(hash);
    }
  }, []);

  return null;
};

export default ViewFile;
